import { Option } from '../../form/fields/dropdown/types'
import { InventoryWarehouse, ItemWarehouse } from './types'

const convertInventoryWarehouseToOption = (
   warehouse: InventoryWarehouse
): Option => ({
   value: String(warehouse.id),
   label: warehouse.label,
})

const convertOptionToInventoryWarehouse = (
   option: Option,
   itemWarehouse?: ItemWarehouse
): InventoryWarehouse => ({
   id: Number(option.value),
   label: option.label,
   quantity: itemWarehouse?.AvailableQuantity ?? 0,
   reorderLevel: itemWarehouse?.ReorderLevelQuantity ?? 0,
   toolWarehouseId: itemWarehouse?.ToolWarehouseID ?? 0,
   isHomeWarehouse: itemWarehouse?.IsHomeWarehouse !== false,
   kitQuantity: itemWarehouse?.KitReservedQuantity ?? 0,
})

const convertItemWarehouseToInventoryWarehouse = (
   itemWarehouse: ItemWarehouse | null
): InventoryWarehouse | null =>
   itemWarehouse
      ? {
           id: itemWarehouse.WarehouseLocationId,
           label: itemWarehouse.WarehouseLocationName,
           quantity: itemWarehouse.AvailableQuantity,
           reorderLevel: itemWarehouse.ReorderLevelQuantity,
           toolWarehouseId: itemWarehouse.ToolWarehouseID,
           isHomeWarehouse: itemWarehouse.IsHomeWarehouse,
           kitQuantity: itemWarehouse.KitReservedQuantity,
        }
      : null

const convertInventoryWarehouseToItemWarehouse = (
   warehouse: InventoryWarehouse | null
): ItemWarehouse | null =>
   warehouse
      ? {
           WarehouseLocationId: warehouse.id,
           WarehouseLocationName: warehouse.label,
           AvailableQuantity: warehouse.quantity,
           ReorderLevelQuantity: warehouse.reorderLevel,
           ToolWarehouseID: warehouse.toolWarehouseId,
           KitReservedQuantity: warehouse.kitQuantity,
           TotalQuantity: 0,
           IsHomeWarehouse: warehouse.isHomeWarehouse,
        }
      : null

const arraysAreEqual = (array1: object[], array2: object[]) => {
   if (array1.length !== array2.length) return false

   const compare = (a, b) => (JSON.stringify(a) > JSON.stringify(b) ? 1 : -1)

   const sortedArr1 = JSON.stringify(array1.toSorted(compare))
   const sortedArr2 = JSON.stringify(array2.toSorted(compare))

   return sortedArr1 === sortedArr2
}

const convertWarehouseOptionToOption = (
   warehouse?: WarehouseOption
): Option | null =>
   warehouse
      ? {
           label: warehouse?.Text,
           value: warehouse?.Value,
        }
      : null

const sortInventoryWarehouses = (warehouses: InventoryWarehouse[]) =>
   warehouses?.length > 0
      ? warehouses.toSorted((a, b) => a.label.localeCompare(b.label))
      : []

export {
   convertInventoryWarehouseToOption,
   convertOptionToInventoryWarehouse,
   arraysAreEqual,
   convertItemWarehouseToInventoryWarehouse,
   convertInventoryWarehouseToItemWarehouse,
   convertWarehouseOptionToOption,
   sortInventoryWarehouses,
}
